import React from 'react';
import PropTypes from 'prop-types';
import './radio-button.scss';

export function RadioButtonGroup({
  required,
  label,
  errorMessage,
  bMargine,
  className,
  ...props
}) {
  return (
    <div className="radio-button-group">
      <span className="label">
        {label}
        {required && <span className="required">*</span>}
      </span>
      <div className={`radio-buttons ${className}`}>{props.children}</div>
      {errorMessage !== '' && (
        <p className="error-message" style={{ marginBottom: bMargine }}>
          {errorMessage}
        </p>
      )}
    </div>
  );
}
RadioButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  bMargine: PropTypes.string,
  className: PropTypes.string,
};
RadioButtonGroup.defaultProps = {
  label: '',
  errorMessage: '',
  required: false,
  bMargine: '',
  className: '',
};

export function RadioButton({
  label,
  value,
  children,
  className,
  hideCircle,
  ...otherProps
}) {
  return (
    <label
      className={`radio-button ${className} ${hideCircle ? 'no-circle' : ''}`}
    >
      <input type="radio" value={value} {...otherProps} />
      <span className="radio-round" />
      <span className="radio-value">
        {label}
        {children}
      </span>
    </label>
  );
}

RadioButton.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  hideCircle: PropTypes.bool,
};
RadioButton.defaultProps = {
  value: '',
  label: '',
  className: '',
  hideCircle: false,
  onChange: () => {},
};
